/** @flow */

import {
  GetEmailControlsSettings,
  GetEmailControlsSettingsSuccess,
  GetEmailControlsSettingsError,
  ToggleAddEmailDomainModal,
  UpdateEmailControlsSettings,
  UpdateEmailControlsSettingsSuccess,
  UpdateEmailControlsSettingsError,
  UploadClientLogo,
  UploadClientLogoSuccess,
  UploadClientLogoError,
} from "@modules/service/constants/actions";
import * as emailControlsReducers from "./reducers";
import initialState from "./state";
import type { EmailControlsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: EmailControlsState = initialState, action: Object): EmailControlsState => {
  const act = {
    [UploadClientLogo]: emailControlsReducers.onUploadClientLogo,
    [UploadClientLogoSuccess]: emailControlsReducers.onUploadClientLogoSuccess,
    [UploadClientLogoError]: emailControlsReducers.onUploadClientLogoError,
    [GetEmailControlsSettings]: emailControlsReducers.onGetEmailControlsSettings,
    [GetEmailControlsSettingsSuccess]: emailControlsReducers.onGetEmailControlsSettingsSuccess,
    [GetEmailControlsSettingsSuccess]: emailControlsReducers.onGetEmailControlsSettingsSuccess,
    [GetEmailControlsSettingsError]: emailControlsReducers.onGetEmailControlsSettingsError,
    [UpdateEmailControlsSettings]: emailControlsReducers.onUpdateEmailControlsSettings,
    [UpdateEmailControlsSettingsSuccess]:
      emailControlsReducers.onUpdateEmailControlsSettingsSuccess,
    [UpdateEmailControlsSettingsError]: emailControlsReducers.onUpdateEmailControlsSettingsError,
    [ToggleAddEmailDomainModal]: emailControlsReducers.onToggleAddEmailDomainModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
